<template>
  <div class="ListItem" v-if="item.title">
    <a :href="item.url">
      <div class="itemImage" :style="'background-image:url(' + item.image + ')'"></div>
      <div class="text">
        <span class="category">{{ item.type_friendly !== undefined ? item.type_friendly : item.type|replace('_', ' ') }}</span>
        <h3>{{ item.title }}</h3>
        <span v-if="item.type === 'artifact' && item.date_historical_display" class="date artifactDate">Artifact Date: {{ item.date_historical_display }}</span>
        <span v-else-if="item.type === 'event' && item.date_historical_display" class="date eventDate">Event Date: July 17, 2018</span>
        <span v-else-if="item.type === 'news' && item.date_published" class="date publishedDate">Published Date: {{ item.date_published | date('%B %-d, %Y') }}</span>
        <span v-else class="date blankDate">&nbsp;</span>
        <!-- <span v-if="item.body" class="description" v-html="item.body"></span> -->
        <span v-if="item.body" class="description">{{ item.body | strip | truncate(400, "...") }}</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ListItem',
  props: ['item']
};
</script>

<style scoped lang="scss">
.ListItem {
  overflow: hidden;
  padding-bottom: 36px;
  @include smx { padding-bottom: 56px; }

  a {
    display: block;

    &:hover .text h3{
      color: $dark-blue;
      transition: color .4s;
    }
  }

  .itemImage {
    background-image: url('/themes/custom/microfiche/search/src/assets/artifact-bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 200px;
    height: 200px;
    display: inline-block;
    @include smx { display: block; width: 200px; height: 200px; }
  }

  .text {
    display: inline-block;
    padding-left: 36px;
    width: calc(100% - 240px);
    vertical-align: top;
    padding-top: 20px;
    padding-right: 80px;
    @include smx { width: 100%; padding-left: 0px; padding-right: 0px; padding-top: 8px; }

    .category {
      font-size: 18px;
      text-transform: uppercase;
      font-family: $gothic;
      padding-bottom: 8px;
      display: inline-block;
      @include smx { padding-bottom: 3px; }
    }

    h3 {
      color: $pink;
      transition: color .4s;
      font-size: 24px;
      padding-bottom: 8px;


    }

    .date {
      font-size: 16px;
      display: block;
      padding-bottom: 13px;
      @include smx { padding-bottom: 10px; }
    }

    .blankDate {
      display: none;
    }

    .description {
      line-height: 1.25;
      font-size: 18px;
    }
  }
}
</style>
